var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadingCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4987 22.538C15.0024 23.2086 13.3751 23.5362 11.7358 23.4968C10.0965 23.4574 8.48682 23.0521 7.02442 22.3104C5.56202 21.5687 4.28393 20.5094 3.28368 19.2101C2.28342 17.9108 1.5863 16.4043 1.24332 14.8008C0.900343 13.1974 0.920182 11.5375 1.30139 9.94271C1.6826 8.3479 2.41553 6.85849 3.44655 5.58346C4.47758 4.30842 5.78062 3.28002 7.26033 2.57349C8.74004 1.86697 10.359 1.50019 11.9987 1.5",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6836 3.76199C18.9296 3.94899 19.1666 4.14799 19.3956 4.35499C19.6246 4.56199 19.8446 4.78099 20.0546 5.00699",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 7.405C21.8933 7.679 22.0247 7.95867 22.144 8.244C22.2633 8.52933 22.3707 8.819 22.466 9.113",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9862 12C23.0002 12.3087 23.0002 12.6177 22.9862 12.927C22.9732 13.235 22.9482 13.544 22.9102 13.85",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1683 16.693C22.0503 16.979 21.9203 17.2593 21.7783 17.534C21.6363 17.8087 21.4836 18.0773 21.3203 18.34",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2852 2C15.6058 2.1 15.9202 2.21433 16.2282 2.343",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7235 20.329C19.4865 20.563 19.2385 20.787 18.9805 20.998",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5C13.5823 4.5 15.129 4.96919 16.4446 5.84824C17.7602 6.72729 18.7855 7.97672 19.391 9.43853C19.9965 10.9003 20.155 12.5089 19.8463 14.0607C19.5376 15.6126 18.7757 17.038 17.6569 18.1569C16.538 19.2757 15.1126 20.0376 13.5607 20.3463C12.0089 20.655 10.4003 20.4965 8.93853 19.891C7.47672 19.2855 6.22729 18.2602 5.34824 16.9446C4.46919 15.629 4 14.0823 4 12.5",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingCircle);
export default __webpack_public_path__ + "static/media/loadingCircle.4bfa2b90f054033723e06ffce85ef14c.svg";
export { ForwardRef as ReactComponent };